import React from 'react'

import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'


function TabPanel(props) {
  const { id, children, value, index, boxProps, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={ value !== index }
      id={ `${ id }-tabpanel-${ index }` }
      aria-labelledby={ `${ id }-tab-${ index }` }
      { ...other }
    >
      {value === index && <Box p={ 3 } { ...boxProps }>{children}</Box>}
    </Typography>
  )
}

TabPanel.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  boxProps: PropTypes.object,
  children: PropTypes.node
}

TabPanel.defaultProps = {
  boxProps: {},
  children: null
}

export default TabPanel
